<template>
    <v-layout>
        <v-flex xs12>
            <!-- Quick Links -->
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <div class="d-inline-flex">
                                <v-checkbox hide-details color="primary" v-model="widget.configurations.quick_links" style="margin-top: -7px;"></v-checkbox>
                            </div>
                            <h2>
                                {{ $t('company_footer_setting_dynamic_footer_quick_link_label') }}
                                <template v-if="widget.configurations.quick_links">
                                    <v-btn class="ml-2" small color="primary" @click="addFooterLinks('quick')"> + Add Link </v-btn>
                                </template>
                            </h2>
                        </v-card-title>
                        <v-card-text v-if="widget.configurations.quick_links">
                            <v-layout v-for="quick_link, quick_index in QuickLinks" :key="quick_index" class="mt-4">
                                <v-card elevation="2">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <!-- Link Name -->
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs4 sm4 v-for="(language, quick_lang_index) in languages" :key="quick_lang_index">
                                                        <v-text-field
                                                            v-model="quick_link.title[language.value]"
                                                            :id="'text-' + language.value+ ' ' + quick_lang_index"
                                                            :label="'Title in ' + language.text"
                                                            name="text"
                                                            counter="255"
                                                            color="primary"
                                                            prepend-icon="$vuetify.icons.rms_agreement"
                                                            type="text"
                                                            class="pr-3"
                                                        />
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider class="mt-3 mb-3"></v-divider>
                                        <v-layout row wrap>
                                            <!-- URL Input -->
                                            <v-flex xs8>
                                                <v-text-field
                                                    :id="`link-${quick_index}`"
                                                    :label="'Link'"
                                                    name="link"
                                                    color="primary"
                                                    prepend-icon="$vuetify.icons.rms_agreement"
                                                    type="text"
                                                    class="pr-3"
                                                    v-model="quick_link.link"
                                                />
                                            </v-flex>
                                            <!-- Tab Selection -->
                                            <v-flex xs12 sm12 md2 lg2>
                                                <v-select
                                                :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                                label="Opens In"
                                                class="pr-3"
                                                :id="`Quick-Traget-${quick_index}`"
                                                v-model="quick_link.target"
                                                />
                                            </v-flex>
                                            <!-- Delete Link -->
                                            <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                                <v-btn color="error" small icon fab @click="removeFooterLinks({type:'quick',removeIndex:quick_index})"><v-icon>mdi-delete</v-icon></v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>

                                </v-card>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Quick Links -->
            <!-- Legal Links -->
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <div class="d-inline-flex">
                                <v-checkbox hide-details color="primary" v-model="widget.configurations.legal_links" style="margin-top: -7px;"></v-checkbox>
                            </div>
                            <h2>
                                {{ $t('company_footer_setting_dynamic_footer_legal_link_label') }}
                                <template v-if="widget.configurations.legal_links">
                                    <v-btn class="ml-2" small color="primary" @click="addFooterLinks('legal')"> + Add Link </v-btn>
                                </template>
                            </h2>
                        </v-card-title>
                        <v-card-text v-if="widget.configurations.legal_links">
                            <v-layout v-for="(legal_link, legal_index) in LegalLinks" :key="legal_index" class="mt-4">
                                <v-card elevation="2">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <!-- Link Name -->
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs4 v-for="(language, legal_lang_index) in languages" :key="legal_lang_index">
                                                        <v-text-field
                                                            v-model="legal_link.title[language.value]"
                                                            :id="'text-' + language.value"
                                                            :label="'Title in ' + language.text"
                                                            name="text"
                                                            counter="255"
                                                            color="primary"
                                                            prepend-icon="$vuetify.icons.rms_agreement"
                                                            type="text"
                                                            class="pr-3"
                                                        />
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider class="mt-3 mb-3"></v-divider>
                                        <v-layout row wrap>
                                            <!-- URL Input -->
                                            <v-flex xs8>
                                                <v-text-field
                                                    :id="'link-'"
                                                    :label="'Link'"
                                                    name="link"
                                                    color="primary"
                                                    prepend-icon="$vuetify.icons.rms_agreement"
                                                    type="text"
                                                    v-model="legal_link.link"
                                                    class="pr-3"
                                                />
                                            </v-flex>
                                            <!-- Tab Selection -->
                                            <v-flex xs12 sm12 md2 lg2>
                                                <v-select
                                                :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                                label="Opens In"
                                                class="pr-3"
                                                v-model="legal_link.target"
                                                />
                                            </v-flex>
                                            <!-- Delete Link -->
                                            <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                                <v-btn color="error" small icon fab @click="removeFooterLinks({type:'legal',removeIndex:legal_index})"><v-icon>mdi-delete</v-icon></v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>

                                </v-card>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Legal Links -->
            <!-- Sical Media Links -->
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <div class="d-inline-flex">
                                <v-checkbox hide-details color="primary" v-model="widget.configurations.social_media_links" style="margin-top: -7px;"></v-checkbox>
                            </div>
                            <h2>
                                {{ $t('company_footer_setting_dynamic_footer_social_media_link_label') }}
                                <v-btn class="ml-2" small color="primary" v-if="widget.configurations.social_media_links" @click="addFooterLinks('social')"> + Add Link </v-btn>
                            </h2>
                        </v-card-title>
                        <v-card-text v-if="widget.configurations.social_media_links">
                            <v-layout row wrap v-for="(social_links, socail_index) in SocalMediaLinks" :key="socail_index">
                                <v-flex xs12>
                                    <v-card elevation="2">
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <!-- Link Name -->
                                                <v-flex xs12 sm12 md3 lg5>
                                                    <v-select
                                                        :items="DEFINES.SOCIAL_MEDIA_LINK_TYPES"
                                                        label="Type"
                                                        class="pr-3"
                                                        v-model="social_links.type"
                                                    />
                                                </v-flex>
                                                <!-- URL Input -->
                                                <v-flex xs12 sm12 md6 lg4>
                                                    <v-text-field
                                                        :id="'link-'"
                                                        :label="'Link'"
                                                        name="link"
                                                        color="primary"
                                                        prepend-icon="$vuetify.icons.rms_agreement"
                                                        type="text"
                                                        class="pr-3"
                                                        v-model="social_links.link"
                                                    />
                                                </v-flex>
                                                <!-- Tab Selection -->
                                                <v-flex xs12 sm12 md2 lg2>
                                                    <v-select
                                                    :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                                    label="Opens In"
                                                    class="pr-3"
                                                    v-model="social_links.target"
                                                    />
                                                </v-flex>
                                                <!-- Delete Link -->
                                                <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                                    <v-btn color="error" small icon fab @click="removeFooterLinks({type:'social',removeIndex:socail_index})"><v-icon>mdi-delete</v-icon></v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
    
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Sical Media Links -->
        </v-flex>
    </v-layout>
</template>

<script>
import DEFINES from "@/defines";
export default {
    name :'FooterWidgetConfiguration',
    props:{
        widget :{
            type:Object,
            default:null
        }
    },
    created(){
        if ('quick_links' in this.widget.data) {
            this.QuickLinks = this.widget.data.quick_links
        }
        if ('legal_links' in this.widget.data) {
            this.LegalLinks = this.widget.data.legal_links
        }
        if ('social_medias_links' in this.widget.data) {
            this.SocalMediaLinks = this.widget.data.social_medias_links
        }
    },
    data() {
        return {
            QuickLinks:[],
            LegalLinks:[],
            SocalMediaLinks:[],
            languages:DEFINES.LOCALES 
        }
    },
    methods: {
        updateQuickLink(index, key, value) {
            this.$set(this.widget.data.quick_links[index], key, value);
        },
        addFooterLinks(type) {
            switch (type) {
                case 'quick':
                    this.QuickLinks.push(JSON.parse(JSON.stringify(DEFINES.WIDGET_QUICK_LINK_DEFAULT)))
                    break;
                case 'legal':
                    this.LegalLinks.push(JSON.parse(JSON.stringify(DEFINES.WIDGET_LEGAL_LINK_DEFAULT)))
                    break;
                case 'social':
                    this.SocalMediaLinks.push(JSON.parse(JSON.stringify(DEFINES.WIDGET_SOCAIL_MEDIA__DEFAULT)))
                    break;
                default:
                    break;
            }
        },
        removeFooterLinks({type, removeIndex}){
            switch (type) {
                case 'quick':
                    this.QuickLinks.splice(removeIndex, 1);
                    break;
                case 'legal':
                    this.LegalLinks.splice(removeIndex, 1);
                    break;
                case 'social':
                    this.SocalMediaLinks.splice(removeIndex, 1);
                    break;
                default:
                    break;
            }
            
        },
    }
                
}
</script>

<style scoped>

</style>